import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setLoading, setGalleryFiles, setAddFileError } from "../../repository/slice";

function* addFilesWorker({ payload }: any): SagaIterator {
    try {
        const formData = new FormData();
        for (const [key, value] of Object.entries(payload as Object)) {
            const isValue = value !== null && value !== undefined && value !== "";
            if (isValue) {
                if (Array.isArray(value)) {
                    value.forEach(file => {
                        formData.append(key, file);
                    });
                } else {
                    formData.append(key, value);
                }
            }
        }; 
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.post, '/api/admin/document/add-files', formData);
        if (isError) {
            yield put(setAddFileError(message));
        } else {
            yield put(setAddFileError(null));
           yield put(setGalleryFiles(data))
        }
    } catch (error) {
        console.error("addFilesWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* addFilesWatcher() {
    yield takeLatest("@saga/ADD_FILES", addFilesWorker);
};
